/**
 * 开发环境 Mock 拦截器
 * 仅在 REACT_APP_MOCK=true 时生效
 */
import axios from 'axios';

import { mockAccount, mockGraphQL } from './mockData';

export function setupMocks() {
  // ── REST /api/user/account ──────────────────────────────────────────────────
  axios.interceptors.request.use((config) => {
    if (config.url?.includes('/user/account')) {
      // @ts-ignore
      config.adapter = async () => ({
        data: mockAccount,
        status: 200,
        statusText: 'OK',
        headers: {},
        config,
      });
    }
    return config;
  });

  // ── GraphQL /graphql/kyb ────────────────────────────────────────────────────
  axios.interceptors.request.use((config) => {
    if (!config.url?.includes('/graphql/kyb')) return config;

    const body = config.data;
    const parsed = typeof body === 'string' ? JSON.parse(body) : body;
    const opName: string = parsed?.operationName ?? '';
    const key = opName ? opName.charAt(0).toLowerCase() + opName.slice(1) : '';
    const mockData = (key && mockGraphQL[key]) ?? {};

    console.info(`[Mock] GraphQL ${opName || 'unknown'} →`, mockData);

    // @ts-ignore
    config.adapter = async () => ({
      data: { data: mockData },
      status: 200,
      statusText: 'OK',
      headers: { 'content-type': 'application/json' },
      config,
    });

    return config;
  });

  console.info('[Mock] 已启用开发环境 Mock 数据');
}
